import * as t from 'io-ts';
import { optional } from '@/api/validators/helper';

const playerInfo = t.type( {
  sportspersonId: optional(t.string),
  playerId: t.string,
  firstName: t.string,
  lastName: t.string,
  shortName: t.string,
  fullName: t.string,
  countryISO3: optional(t.string),
  countryCode: optional(t.string),
});

const ranking = t.type( {
  isTie: t.boolean,
  player: playerInfo,
  points: t.number,
  rank: t.number,
  eventsPlayed: optional(t.number),
});

export type TennisRanking = t.TypeOf<typeof ranking>;

export const rankingApiResponse = t.array(ranking);
export type TennisRankings = t.TypeOf<typeof rankingApiResponse>;
